import React from 'react'
import Filtro from '../../comum/Filtro'
import FiltrosAdicionadosUsuarioAgencia from './FiltrosAdicionadosUsuarioAgencia'
import FiltroUsuarioAgencia from './FiltroUsuarioAgencia'
import PainelFiltragem from '../../comum/PainelFiltragem'

export const PainelFiltrosUsuarioAgencia = () => (
  <Filtro PainelFiltro={FiltroUsuarioAgencia}/>
);

const PainelFiltrosUsuariosAgencia = () => (
  <PainelFiltragem
    Filtro={PainelFiltrosUsuarioAgencia}
    FiltrosAdicionados={FiltrosAdicionadosUsuarioAgencia}/>
)

export default PainelFiltrosUsuariosAgencia
